import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  buildTripPlannerSnapshot,
  buildTripPlannerStateTool,
  emitItpStateChanged,
  itineraryStepFromPath,
} from '../pageTools/itpPageTools';
import { usePageTools } from './usePageTools';

// Gated by the isItpPagetools cookie inside usePageTools. Conv UI companion
// sync requires vzgptPageToolsFFlag plus REQUEST_PAGE_TOOLS / EXECUTE_PAGE_TOOL.

const wrapMutatingExecute = tool => {
  if (tool.annotations?.readOnlyHint) {
    return tool;
  }
  const { execute, ...definition } = tool;
  return {
    ...definition,
    execute: (...args) => {
      const result = execute(...args);
      if (!result?.isError) {
        emitItpStateChanged();
      }
      return result;
    },
  };
};

export const useItpTripSnapshotGetter = (overrides = {}) => {
  const location = useLocation();
  const selectedReducer = useSelector(state => state?.selectedReducer) ?? {};
  const persistantReducer = useSelector(state => state?.persistantReducer) ?? {};
  const overridesRef = useRef(overrides);
  overridesRef.current = overrides;

  return () => {
    const extra = overridesRef.current;
    return buildTripPlannerSnapshot({
      step: extra.step ?? itineraryStepFromPath(location.pathname),
      destinations:
        extra.destinations ??
        persistantReducer.selectedDestinations ??
        selectedReducer.selectedDestinations,
      travelDates:
        extra.travelDates ??
        persistantReducer.selectedDates ??
        selectedReducer.selectedDates,
      selectedLine:
        extra.selectedLine ?? selectedReducer.selectedDeviceDetails,
      stagedPlanChanges:
        extra.stagedPlanChanges ?? persistantReducer.confirmedPlanData,
      confirmed: extra.confirmed ?? Boolean(selectedReducer.loadConfirmPage),
    });
  };
};

export const useItpPageTools = (ownerId, tools, snapshotOverrides) => {
  const getSnapshot = useItpTripSnapshotGetter(snapshotOverrides);
  const toolsWithState = [
    ...tools.map(wrapMutatingExecute),
    buildTripPlannerStateTool(getSnapshot),
  ];
  usePageTools(ownerId, toolsWithState);
};
